import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";
import { logoutUser } from "@/auth/authSlice";
import { TranslatedText } from "@/components/common/text";
import { Logout } from "@/components/common/svgs";
import { Hr } from "@/components/common/other/Hr";
import {
    ProfileAccountSection,
    ProfileCard,
    ProfileCompanySection,
    ProfilePreferenceRow,
    ProfileSection,
    ThemeSwitcher,
    TrailerTypeChips,
    TruckListToggle,
} from "@/components/profile";

export const Profile = () => {
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleBack = () => {
        // Opened directly (no in-app history): go home instead of leaving the app.
        if (window.history.state?.idx > 0) navigate(-1);
        else navigate("/");
    };

    return (
        <div className="mx-auto flex w-full max-w-[600px] flex-col items-start gap-6 px-6 pb-12 pt-8 md:px-0">
            <button
                type="button"
                onClick={handleBack}
                className="flex h-11 items-center gap-2 rounded-md bg-cm-p-surface-container pl-3 pr-4 text-sm font-medium text-cm-p-text-primary hover:bg-cm-p-surface-container-hover"
            >
                <ArrowLeft className="size-4" />
                <TranslatedText>Back</TranslatedText>
            </button>

            <div className="flex w-full flex-col gap-4">
                <ProfileCard>
                    <ProfileAccountSection />
                    <Hr className="my-0" />
                    <ProfileCompanySection />
                    <ProfileSection
                        title="Public truck list"
                        description="Share a public page listing your available trucks. Anyone with the link can view it."
                        className="gap-0"
                    >
                        <TruckListToggle />
                    </ProfileSection>
                </ProfileCard>

                <ProfileCard>
                    <ProfileSection title="Preferences" />
                    <ProfilePreferenceRow label="Dark theme">
                        <ThemeSwitcher />
                    </ProfilePreferenceRow>
                    <ProfilePreferenceRow label="Default trailer type">
                        <TrailerTypeChips />
                    </ProfilePreferenceRow>
                    {profile.updateError && <div className="text-sm text-cm-error">{profile.updateError}</div>}
                </ProfileCard>

                <ProfileCard>
                    <button
                        type="button"
                        onClick={() => dispatch(logoutUser())}
                        className="flex items-center gap-3 self-start text-sm font-medium text-cm-p-destructive"
                    >
                        <Logout className="size-6" />
                        <TranslatedText>Sign out</TranslatedText>
                    </button>
                </ProfileCard>
            </div>
        </div>
    );
};
